import { SHStack, SHStackProps } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";

interface TableAnalysisCellSkeletonProps {
  isTableHead?: boolean;
  isFirstColumn?: boolean;
  isLastColumn?: boolean;
  delay?: boolean;
}

const DebounceTime = 300;

export const TableAnalysisCellSkeleton = ({
  isTableHead = false,
  isFirstColumn = false,
  isLastColumn = false,
  delay = false,
  ...others
}: TableAnalysisCellSkeletonProps & SHStackProps) => {
  const { palette } = useTheme();

  const [isShown, setIsShown] = useState(!delay);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true);
    }, DebounceTime);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {isShown && (
        <SHStack
          alignItems={"center"}
          justifyContent={"center"}
          sx={{
            border: `1px solid ${palette.secondary[100]}`,
            padding: "5px 5px",
            borderRight: !isLastColumn ? "none" : undefined,
            borderBottom: !isTableHead ? "none" : undefined,
          }}
          {...others}
        >
          <SHSkeleton
            variant="rectangular"
            height={isTableHead ? 245 : 54}
            width={isFirstColumn ? 313 : 190}
            delay={delay}
          />
        </SHStack>
      )}
    </>
  );
};
